import { Identifiable } from "./identifiable";
import { Project } from "./project";
import { List } from "./list";
import { Constraint } from "./constraint";

type Gantt = {
  projects: (Identifiable<Project> & {
    lists: Identifiable<List>[];
    shallow?: boolean;
  })[];
  constraints: Identifiable<Constraint>[];
};

const gantt: Gantt = {
  projects: [],
  constraints: [],
};

export type { Gantt };

export { gantt };
